import React from 'react';
import { History, MessageSquare, Clock, Trash2, Loader2, Plus } from 'lucide-react';
import { Button } from '../ui/button';
import { ScrollArea } from '../ui/scroll-area';

/**
 * Chat history sidebar component
 */
export const ChatHistoryPanel = ({
    chatHistory,
    loadingHistory,
    onLoadSession,
    onDeleteSession,
    onNewChat,
    onClose
}) => {
    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        return date.toLocaleDateString('ro-RO', {
            day: '2-digit',
            month: 'short',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    return (
        <div className="absolute inset-0 bg-white z-10 flex flex-col">
            {/* Header */}
            <div className="flex items-center justify-between p-4 border-b border-gray-200">
                <div className="flex items-center gap-2 font-medium">
                    <History className="w-5 h-5 text-gray-600" />
                    Istoric Conversații
                </div>
                <Button
                    variant="ghost"
                    size="sm"
                    onClick={onClose}
                >
                    Închide
                </Button>
            </div>
            
            {/* New Chat Button */}
            <div className="p-3 border-b border-gray-100">
                <Button
                    variant="outline"
                    className="w-full justify-start gap-2"
                    onClick={onNewChat}
                >
                    <Plus className="w-4 h-4" />
                    Conversație nouă
                </Button>
            </div>
            
            {/* History List */}
            <ScrollArea className="flex-1">
                {loadingHistory ? (
                    <div className="flex items-center justify-center p-8">
                        <Loader2 className="w-6 h-6 animate-spin text-gray-400" />
                    </div>
                ) : chatHistory.length === 0 ? (
                    <div className="flex flex-col items-center justify-center p-8 text-gray-400">
                        <MessageSquare className="w-10 h-10 mb-2 opacity-50" />
                        <p className="text-sm">Nicio conversație salvată</p>
                    </div>
                ) : (
                    <div className="p-2 space-y-1">
                        {chatHistory.map((session) => (
                            <div
                                key={session.id}
                                className="group flex items-start gap-2 p-3 rounded-lg hover:bg-gray-50 cursor-pointer transition-colors"
                                onClick={() => onLoadSession(session.id)}
                            >
                                <MessageSquare className="w-4 h-4 text-gray-400 mt-0.5 flex-shrink-0" />
                                <div className="flex-1 min-w-0">
                                    <p className="text-sm text-gray-700 line-clamp-2">
                                        {session.preview || 'Conversație'}
                                    </p>
                                    <div className="flex items-center gap-1 mt-1 text-xs text-gray-400">
                                        <Clock className="w-3 h-3" />
                                        {formatDate(session.created_at)}
                                    </div>
                                </div>
                                <button
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onDeleteSession(session.id);
                                    }}
                                    className="opacity-0 group-hover:opacity-100 p-1 text-gray-400 hover:text-red-500 transition-all"
                                    title="Șterge"
                                >
                                    <Trash2 className="w-4 h-4" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </ScrollArea>
        </div>
    );
};

export default ChatHistoryPanel;
